export default __webpack_public_path__ + "static/media/bra-material-2.39e69630.webp";